// extracted by mini-css-extract-plugin
export default {"patientIdentityBlockNames":"PatientIdentityBlock_patientIdentityBlockNames__9unhg"};